const cartActionTypes = {
    FETCH_CART_SUCCESS: 'FETCH_CART_SUCCESS',
    FETCH_CART_FAILURE: 'FETCH_CART_FAILURE',
    ADD_ITEM_TO_CART: 'ADD_ITEM_TO_CART',
    REDUCE_ITEM_FROM_CART: 'REDUCE_ITEM_FROM_CART',
    REMOVE_ITEM_FROM_CART: 'REMOVE_ITEM_FROM_CART',
    CLEAR_CART: 'CLEAR_CART',
    TOGGLE_CART_DROPDOWN: 'TOGGLE_CART_DROPDOWN',
    HIDE_CART_DROPDOWN: 'HIDE_CART_DROPDOWN',
};

export default cartActionTypes;
